export const sanitizeText = (source: string): string => {
  return source.replace(/\s/g, '');
};
